module.exports = __webpack_public_path__ + "static/img/guidef.1bab290d.png";